import ProgramImage from 'core/modules/components/general/ProgramImage/ProgramImage';
import React from 'react';

const BookSelect = ({ cover, name }) => {
  return (
    <div className="book-select">
      <ProgramImage configProgramPicture={true} course_picture={cover} />
      <div className="book-select__name">{name}</div>
    </div>
  );
};

export default BookSelect;
